module.exports = __webpack_public_path__ + "static/media/move-forward-tool-white.97972596.svg";